import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useRouter} from 'next/router';
import useCommon from '@utils/hooks/common';
import PopupContainer from '@components/layout/PopupContainer';
import GradientButton from '@components/GradientButton';
import styles from './styles';

interface TournamentThanksForJoiningModalSheetProps {
  isModalSheetOpen: boolean;
  onModalSheetClose: () => void;
  tournamentName: string;
  tournamentId: number;
}

const TournamentThanksForJoiningModalSheet: React.FC<TournamentThanksForJoiningModalSheetProps> = ({
  isModalSheetOpen,
  onModalSheetClose,
  tournamentName,
  tournamentId,
}) => {
  const {t, system, classes} = useCommon({
    withTranslation: ['tournament'],
    withStyles: {styles, hasProps: true},
    observers: ['system'],
  });
  const router = useRouter();

  useEffect(() => {
    const handleModalClose = () => {
      onModalSheetClose();
    };
    system.on('thanksForJoiningOnClose', handleModalClose);
    return () => {
      system.off('thanksForJoiningOnClose', handleModalClose);
    };
  }, [onModalSheetClose, system]);

  const handleViewResult = () => {
    onModalSheetClose();
    router.push({
      pathname: '/tournament',
      query: {
        tournamentId,
        showResult: true,
      },
    });
    system?.hideGameOverlay();
  };

  return (
    <PopupContainer
      visible={isModalSheetOpen}
      onCancel={onModalSheetClose}
      title={t('tournament:thanks_for_joining.title')}
      mobileModalProps={{snapPoints: [570, 0]}}
    >
      <div className={classes.container}>
        <div className={classes.topSection}>
          <img height={200} src="/images/tournament/thanks_joining.svg" />
          <div style={{textAlign: 'center', lineHeight: '1.5'}}>
            {t('tournament:thanks_for_joining.description', {tournamentName})}
          </div>
        </div>
        <div className={classes.bottomSection}>
          <GradientButton
            isBlue={true}
            style={{height: 50, marginBottom: 10}}
            className={classes.closeButton}
            onClick={handleViewResult}
          >
            {t('tournament:see_result')}
          </GradientButton>
          <GradientButton
            isBlue={false}
            style={{height: 50}}
            className={classes.closeButton}
            onClick={onModalSheetClose}
          >
            {t('common:close')}
          </GradientButton>
        </div>
      </div>
    </PopupContainer>
  );
};

export default TournamentThanksForJoiningModalSheet;
